import React, { useEffect } from "react"
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import Nav from "../components/NavBar"
import { getDetails, resetDetail } from '../redux/actions';
import styles from '../styles/details.module.css';
import balto from '../assets/img/balto.jpg'
import dog from '../assets/img/black-dog.png'
import blue from '../assets/img/dog-blue.jpg'
import illustration from '../assets/img/illustration.jpg'
import Loading from "../components/Loading";


export default function Details() {

    let { id } = useParams(state => state.details);
    let dispatch = useDispatch()

    const details = useSelector(state => state.todos.details)

    useEffect(() => {
        dispatch(getDetails(id))
        return () => {
            dispatch(resetDetail())
        }
    }, [dispatch, id])

    let temp = details.temperaments !== null ? details.temperaments : ['has no temperament']


    function jurasic(val) {
        let data = val.map(e => {
            if (e.hasOwnProperty('name')) return e.name
            else { return (e) }
        })
        return data
    }

    const data = () => {
        if (details.hasOwnProperty('created')) {
            return (
                <div>
                    <span><i>from</i>&nbsp;<code>{details.min_Height}</code>cm</span>
                    &nbsp;<i>to</i>&nbsp;<span><code>{details.max_Height} </code>cm</span>
                </div>
            )

        } else {
            return (
                details.min_Height === null || details.max_Height === null ?
                    <span>
                        <code>min &nbsp; 0 &nbsp;cm</code>&nbsp;<i>to</i> &nbsp;
                        <code>max  &nbsp; 0  &nbsp;cm</code>
                    </span>
                    :
                    <div>
                        <span>
                            <i>from</i><code>&nbsp;{details.min_Height}&nbsp;</code>
                        </span>&nbsp;<i>to</i>&nbsp;
                        <span>
                            <code>&nbsp;{details.max_Height}&nbsp;cm</code>
                        </span>
                    </div>
            )
        }
    }

    const dbImage = [balto, dog, blue, illustration]
    let random = Math.floor(Math.random() * dbImage.length)

    return (
        <div className={styles.detail}>
            <Nav />
            <div className={styles.card_container}>
                {
                    details.hasOwnProperty('name') ?
                        <div className={styles.card_content}>

                            <img src={details.image ? details.image : dbImage[random]} alt='no igame now' />

                            <div className={styles.card_name}>
                                <h2>{details.name}</h2>
                            </div>
                            <div className={styles.container_det_child_option}>
                                {
                                    jurasic(temp).map(e => {
                                        return (<option className={styles.container_child_option} key={`2${e}`}>&#9733;</option>)
                                    })
                                }
                            </div>


                            <div className={styles.temp}>
                                {
                                    <div className={styles.container_det}>
                                        <div className={styles.container_det_child}>
                                            <h4>Heigt</h4>
                                            {data()}
                                        </div>

                                        <div className={styles.container_det_child}>
                                            <h4>Weight:</h4>
                                            <i>from</i>
                                            <code>{details.min_Weight}</code>kg<i>to</i>
                                            <code>{details.max_Weight}</code>kg
                                        </div>
                                        {/* <i class="bi bi-activity"></i> */}
                                        <div className={styles.container_det_child}>
                                            <h4> Life_span </h4>
                                            {
                                                details.hasOwnProperty('created') ?
                                                    <span>
                                                        <code>{details.life_span_min}</code><i>to</i>;
                                                        <code>{details.life_span_max} years</code>
                                                    </span>
                                                    :
                                                    <span>
                                                        <code>{details.life_span}</code>
                                                    </span>
                                            }
                                        </div>

                                        <div className={styles.container_det_child}>
                                            <h4>Temperaments </h4>
                                            {
                                                jurasic(temp).map(e => {
                                                    return (<option key={`2${e}`}>*{e.toString()}&nbsp;</option>)
                                                })
                                            }
                                        </div>
                                    </div>

                                }

                            </div>
                        </div> :
                        <div>
                            <Loading />
                        </div>
                }
                <div>

                </div>
            </div>

        </div>
    )
}